import { render, staticRenderFns } from "./Footnotes.vue?vue&type=template&id=c291847c&scoped=true"
import script from "./Footnotes.vue?vue&type=script&lang=ts"
export * from "./Footnotes.vue?vue&type=script&lang=ts"
import style0 from "./Footnotes.vue?vue&type=style&index=0&id=c291847c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c291847c",
  null
  
)

export default component.exports